import React from "react";
import "./featured.css";
import ParisImg from "../../Media/Photos Gallery/fashionweek.png";
import WeddingIng from "../../Media/Photos Gallery/wedding.png";
import Prom from "../../Media/Photos Gallery/prom.png";

export default function Featured() {
  return (
    <div className="featured">
      <h6 className="small-header">Featured Projects</h6>
      <h3>Prestigious occasions our designed products were endorsed.</h3>
      <div className="featured-boxes">
        <div className="featured-box">
          <img src={ParisImg} alt="featured project" loading="lazy" decoding="async" />
          <h4>Paris Fashion Week</h4>

        </div>
        <div className="featured-box">
          <img src={WeddingIng} alt="featured project" loading="lazy" decoding="async" />
          <h4>Mr. and Mrs. Tetteh Wedding.</h4>

        </div>
        <div className="featured-box">
          <img src={Prom} alt="featured project" loading="lazy" decoding="async" />
          <h4>Doreen's Prom</h4>

        </div>
      </div>
    </div>
  );
}
